export default {
    endPoints: {
        currentFollowups: '/followup',
        followupDetailList: '/followupDetail'
    }
}

export * from "./FollowUps"
export * from "./Actions"